import * as THREE from "three";
import { CREATOR_DATA_TYPES } from "@/types/Creator";

export const DEFAULT_CREATOR = "bestiarum";
export const OG_BANK = "onlyGamesBank";
export const PROD = "production";

// LocalStorage keys
export const STORAGE_KEY_AO_ENABLED = "graphics_ao_enabled";
export const STORAGE_KEY_SHADOWS_ENABLED = "graphics_shadows_enabled";

// Constants for menu type filtering
export const OPTION_TYPES = new Set([
  CREATOR_DATA_TYPES.GROUP,
  CREATOR_DATA_TYPES.SET,
  CREATOR_DATA_TYPES.SETS,
  CREATOR_DATA_TYPES.ATTACHMENT
]);

export const ASSET_TYPES = new Set([
  CREATOR_DATA_TYPES.CHARACTER,
  CREATOR_DATA_TYPES.MODEL
]);

export const GROUP_TYPES = { BASE: "base", CHARACTERS: "characters" };

export const ARMS = { DOUBLE: "doubleArm", L: "armL", R: "armR" };

export const BASE_CHILD = {
  RING: "baseRing",
  NAMEPLATE: "nameplate",
  FONTS: "nameplateFonts",
  PLATE: "plate"
};

export const NAME_PLATE_CHARACTERS = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "!",
  '"',
  "#",
  "$",
  "%",
  "&",
  "'",
  "(",
  ")",
  "*",
  "+",
  ",",
  "-",
  ".",
  "/",
  ":",
  ";",
  "<",
  "=",
  ">",
  "?",
  "@",
  "[",
  "\\",
  "]",
  "^",
  "_",
  "`",
  "{",
  "|",
  "}",
  "~"
];

export const NAME_PLATE_VARIATION = {
  S: "small",
  M: "medium",
  L: "large"
};

export const PLATE_R_VALUE = {
  S: 0.3,
  M: 1.4
};

export const MODE_CONFIG = [
  // {
  //   key: "translate" as const,
  //   icon: "/resources/icons/translate.svg",
  //   label: "Move",
  //   shortcut: "T"
  // },
  {
    key: "rotate" as const,
    icon: "/resources/icons/rotate.svg",
    label: "Rotate",
    shortcut: "R"
  }
  // {
  //   key: "scale" as const,
  //   icon: "/resources/icons/scale.svg",
  //   label: "Scale",
  //   shortcut: "S"
  // }
];

export const TARGET = new THREE.Vector3(2, 20, 0);
export const DEFAULT_SCALE = 1;
